// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"b0932cca","245":"11265782","525":"1c90fdc8","582":"6d666190","615":"08961968","703":"81737f09","802":"41ecdefb","855":"34ec0708"}[chunkId] + ".chunk.js";
};